export default function FeaturesOne(){
    return(
        <section className="feature-area">
		<div className="container">
			<div className="row">
				<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
					<div className="single-feature">
						<div className="feature-content">
							<h6>Free 15-Days Use Trial</h6>
							<div className="f-icon">
								<img src="assets/img/icon/f-1a.png" alt="F-icon" />
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
					<div className="single-feature">
						<div className="feature-content">
							<h6>Flexiable Pricing Plan To Start</h6>
							<div className="f-icon">
								<img src="assets/img/icon/f-1b.png" alt="F-icon" />
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
					<div className="single-feature">
						<div className="feature-content fc-3">
							<h6>Intergate With Popular Software</h6>
							<div className="f-icon">
								<img src="assets/img/icon/f-1c.png" alt="F-icon" />
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
					<div className="single-feature">
						<div className="feature-content fc-3">
							<h6>Update Lifetime & Dedicate Support</h6>
							<div className="f-icon">
								<img src="assets/img/icon/f-1d.png" alt="F-icon" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    )
}